import { EmailAuthProvider, GoogleAuthProvider } from "@angular/fire/auth";

export const firebaseUiAuthConfig: firebaseui.auth.Config = {
  // signInSuccessUrl: '/',
  signInFlow: 'popup',
  signInOptions: [
    EmailAuthProvider.PROVIDER_ID,
  ],
  tosUrl: 'https://www.google.com/',
  privacyPolicyUrl: 'https://www.google.com/',
};
